import React from "react";
import TopBanner from "../components/TopBanner";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ValuePropositions from "../components/ValuePropositions";
import OfferSubmission from "../components/OfferSubmission";
import ProcessSection from "../components/ProcessSection";
import AboutSection from "../components/AboutSection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <TopBanner />
      <Header />
      <HeroSection />
      <ValuePropositions />
      <OfferSubmission />
      <ProcessSection />
      <AboutSection />
      <CTASection />
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default HomePage;